"use strict";

exports.__esModule = true;
exports.TRANSFORM_TYPE_FILL = exports.TRANSFORM_TYPE_FIT = void 0;
var TRANSFORM_TYPE_FIT = 'fit';
exports.TRANSFORM_TYPE_FIT = TRANSFORM_TYPE_FIT;
var TRANSFORM_TYPE_FILL = 'fill';
exports.TRANSFORM_TYPE_FILL = TRANSFORM_TYPE_FILL;